import type {
  NavigationBreadcrumbEntity,
  NavigationStateEntity,
} from '@/domains/navigation/navigation.entity';
import type { NavigationRepository } from '@/domains/navigation/navigation.repository';

/**
 * Implementación concreta del repositorio de navegación usando Zustand
 * Implementa ISP: Interface específica para navegación
 */
export class ZustandNavigationRepository implements NavigationRepository {
  constructor(
    private readonly getState: () => NavigationStateEntity,
    private readonly setState: (
      update: (state: NavigationStateEntity) => NavigationStateEntity,
    ) => void,
  ) {}

  getCurrentNavigationState(): NavigationStateEntity {
    return this.getState();
  }

  addBreadcrumb(breadcrumb: NavigationBreadcrumbEntity): void {
    this.setState((currentState) => ({
      breadcrumbs: [...currentState.breadcrumbs, breadcrumb],
      currentTitle: breadcrumb.title,
    }));
  }

  navigateBackToIndex(targetIndex: number): NavigationStateEntity {
    let updatedState: NavigationStateEntity;

    this.setState((currentState) => {
      const updatedBreadcrumbs = currentState.breadcrumbs.slice(
        0,
        targetIndex + 1,
      );
      updatedState = {
        breadcrumbs: updatedBreadcrumbs,
        currentTitle:
          updatedBreadcrumbs[updatedBreadcrumbs.length - 1]?.title || '',
      };
      return updatedState;
    });

    return updatedState!;
  }

  clearNavigationStack(): void {
    this.setState(() => ({
      breadcrumbs: [],
      currentTitle: '',
    }));
  }

  setCurrentTitle(title: string): void {
    this.setState((currentState) => ({
      ...currentState,
      currentTitle: title,
    }));
  }
}
